// components/PromoUsersWrapper.js
import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PromoUsersTable from './promouserstable';

function PromoUsersWrapper() {
  const { promoCode } = useParams();

  const query = new URLSearchParams(useLocation().search);
  const accessToken = query.get('accessKey');

  return <PromoUsersTable 
    promoCode={promoCode} 
    accessToken={accessToken}
  />;
}

export default PromoUsersWrapper;